/**
 * Countdown
 * @description Web component used to show a countdown related to the usage of a discount code.
 */

(async () => {
  if (!customElements.get('countdown-timer')) {
    class CountdownTimer extends HTMLElement {
      constructor() {
        super();

        // Set default options
        this.options = {
          hours: 24,
          storageKey: 'countdown-ends-at',
        };

        // Expand with additional options
        const options = this.dataset.options ? JSON.parse(this.dataset.options) : {};

        this.options = {
          ...this.options,
          ...options,
        };

        // Set deadline time data
        const deadlineFromStorage = this.getDeadlineFromStorage();
        const now = Date.now();

        if (deadlineFromStorage && parseInt(deadlineFromStorage, 10) - now > 0) {
          this.deadline = deadlineFromStorage;
        } else {
          this.deadline = now + this.options.hours * 60 * 60 * 1000;
          localStorage.setItem(this.options.storageKey, this.deadline);
        }

        // Start timer
        this.timer();
      }

      /**
       * Counts down the seconds and changes the DOM accordingly
       * @returns void
       */
      timer() {
        const elemHours = this.querySelector('[data-timer-hours');
        const elemMinutes = this.querySelector('[data-timer-minutes');
        const elemSeconds = this.querySelector('[data-timer-seconds');

        const interval = setInterval(() => {
          // Get remaining time
          const t = this.deadline - Date.now();
          const hours = Math.floor((t / (1000 * 60 * 60)) % 24);
          const minutes = Math.floor((t / 1000 / 60) % 60);
          const seconds = Math.floor((t / 1000) % 60);

          // Stop counting, remove the storage item, hide the component and exit
          if (t < 0) {
            clearInterval(interval);
            localStorage.removeItem(this.options.storageKey);
            // Remove the element completely
            setTimeout(() => {
              this.remove();
            }, 100);
            return;
          }

          // Update DOM elements
          elemHours.innerHTML = ('0' + hours).slice(-2);
          elemMinutes.innerHTML = ('0' + minutes).slice(-2);
          elemSeconds.innerHTML = ('0' + seconds).slice(-2);
        }, 1000);
      }

      /**
       * Gets (epoch milliseconds) from storage and converts to number
       * @returns number | null
       */
      getDeadlineFromStorage() {
        const deadline = localStorage.getItem(this.options.storageKey);
        return deadline ? parseInt(deadline, 10) : null;
      }

    }

    window.CountdownTimer = CountdownTimer;
    customElements.define('countdown-timer', CountdownTimer);
  }
})();
